import {
  AddCompliancePayload,
  ComplianceDetails,
  ComplianceHistoryResponse,
  Department,
  DepartmentWiseEmployeePayload,
  DepartmentWiseEmployeeResponse,
  ExportCompliancePayload,
  GetAllComplianceDetailsResponse,
  GetAllCompliancesQueryParams,
  UpcomingComplianceItem,
} from '../../../types/ComplianceReminder/ComplianceReminderType'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { AllowedHttpMethods, complianceReminderApiConfig } from '../apiList'

const getAllComplianceDetails = async (
  props: GetAllCompliancesQueryParams,
): Promise<GetAllComplianceDetailsResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.getAllComplianceDetails,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 20,
      startIndex: props.startIndex ?? 0,
      department: props.department,
      dueDate: props.dueDate,
      status: props.status,
      country: props.country,
      complianceStatus: props.complianceStatus,
      search: props.search,
      from: props.from,
      to: props.to,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addNewCompliance = async (
  props: AddCompliancePayload,
): Promise<AddCompliancePayload> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.addNewCompliance,
    method: AllowedHttpMethods.post,
    data: props,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const updateCompliance = async (
  updateComplianceDetails: ComplianceDetails,
): Promise<ComplianceDetails> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.updateCompliance,
    method: AllowedHttpMethods.put,
    data: updateComplianceDetails,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getComplianceHistory = async (
  id: number,
): Promise<ComplianceHistoryResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.getComplianceHistory,
    method: AllowedHttpMethods.get,
    params: {
      id,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getDepartmentList = async (): Promise<Department[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.getDepartmentList,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getUpcomingComplianceDueDates = async (): Promise<
  UpcomingComplianceItem[]
> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.getUpcomingComplianceDueDates,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
// api.ts
const getDepartmentWiseEmployeesList = async (
  payload: DepartmentWiseEmployeePayload,
): Promise<DepartmentWiseEmployeeResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.getDepartmentWiseEmployeesList,
    method: AllowedHttpMethods.get,
    params: {
      departmentName: payload.departmentName ?? '',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const exportCompliance = async (
  payload: ExportCompliancePayload,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: complianceReminderApiConfig.exportCompliance,
    method: AllowedHttpMethods.get,
    params: {
      department: payload.department ?? '',
      // complianceStatus: payload.complianceStatus ?? '',
      dueDate: payload.dueDate ?? '',
      country: payload.country ?? '',
      search: payload.search ?? '',
      from: payload.from ?? '',
      to: payload.to ?? '',
      complianceStatus:
        payload.complianceStatus === 'Pending' ||
        payload.complianceStatus === 'Completed' ||
        payload.complianceStatus === 'OverDue'
          ? payload.complianceStatus
          : '',
      status:
        payload.status === 'Active' || payload.status === 'InActive'
          ? payload.status
          : '',
      // responsiblePerson: payload.responsiblePerson ?? '',
      // complianceName: payload.complianceName ?? '',
      // completedDate: payload.completeDate ?? '',
      // complianceCycle: payload.complianceCycle ?? '',
      // complianceId: payload.complianceId ?? '',
    },
    responseType: 'blob', // For Excel/CSV download
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const ComplianceReminderApi = {
  getAllComplianceDetails,
  addNewCompliance,
  updateCompliance,
  getComplianceHistory,
  getDepartmentWiseEmployeesList,
  exportCompliance,
  getDepartmentList,
  getUpcomingComplianceDueDates,
}

export default ComplianceReminderApi
